import { Component, Input, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { properties } from "src/environments/properties";
import { SubscriptionService } from "../../../shared/services/subscription.service";

@Component({
  selector: "app-change-plan",
  templateUrl: "./change-plan.component.html",
  styleUrls: ["./change-plan.component.scss"],
})
export class ChangePlanComponent implements OnInit {
  @Input() userSubscriptionDetails: any;
  @Input() userInfo: any;
  @Input() currentEnvironment;
  @Input() fetchedPlans;
  nonSelectedSubscriptionType: any;
  pricingDetail: any;
  currentPlanExpiryDate: string;
  governmentAssisted = "";
  properties = properties;

  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

  constructor(
    public subscriptionService: SubscriptionService,
    private titleService: Title
  ) {
    this.setTitle(`${this.programDisplayData.title} - Change Plan`);
  }

  ngOnInit(): void {
    if (this.fetchedPlans) {

      //if subscriptionplan is gov assisted, then prepend govassisted to info message
      const subscriptions = this.fetchedPlans?.Data?.subscriptions || [];
      const value = subscriptions?.some(
        (plan) => plan.promoCategory === this.programDisplayData?.planCard?.SNAP
      );
      this.governmentAssisted = value ? this.programDisplayData?.changePlan?.govtAssisted : "";
      
      
      if (this.userSubscriptionDetails) {
        this.analyticsUserSubscriptionInfo(this.userSubscriptionDetails);
        if (
          this.userSubscriptionDetails.subscriptionType ===
          this.programDisplayData?.planCard?.MonthlyPlan
        ) {
          this.nonSelectedSubscriptionType = this.programDisplayData?.confirmation?.ANNUAL;
        } else {
          this.nonSelectedSubscriptionType = this.programDisplayData?.confirmation?.MONTHLY;
        }

        if (this.userSubscriptionDetails.pricingDetail === " / month") {
          this.pricingDetail = this.programDisplayData?.changePlan?.month;
        } else {
          this.pricingDetail = this.programDisplayData?.changePlan?.year;
        }
        if (this.userSubscriptionDetails.curentPlanExpiryDate) {
          this.currentPlanExpiryDate = this.subscriptionService.convertDate(
            this.userSubscriptionDetails.curentPlanExpiryDate
          );
        }
      }
    }
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  analyticsUserSubscriptionInfo(userSubscriptionDetails) {
    if (
      userSubscriptionDetails.subscriptionStatus === this.programDisplayData?.manage?.TRIAL ||
      userSubscriptionDetails.subscriptionStatus === this.programDisplayData?.changePlan?.trial
    ) {
      localStorage.setItem("analyticsTrialFPUpdate", "true");
    }
    if (userSubscriptionDetails.isExtendedTrialDuration) {
      localStorage.setItem(
        "analyticsFPExtPlan",
        userSubscriptionDetails.isExtendedTrialDuration
      );
    }
    if (userSubscriptionDetails.isDiscountedPrice) {
      localStorage.setItem(
        "analyticsFPDiscountPlan",
        userSubscriptionDetails.isDiscountedPrice
      );
    }
  }

  getCurrentPlanExpiryDate(currentPlanExpiryDate): string {
    const date = new Date(currentPlanExpiryDate);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options).replace(",", "");
  }
}
